import { useMemo, memo } from 'react';
import classNames from 'classnames';

import AttributeType from 'types/Attribute';
import { Classes } from 'types/Classes';

import Attribute from './components/Attribute/Attribute';
import classes from './Attributes.module.scss';

export type Mode = 'small' | 'medium' | 'large' | 'nested';
export type Display = 'inline' | 'block';

type Props = {
  mode: Mode;
  display?: Display;
  classes?: Classes<'wrapper'>;
  singleColumn?: boolean;
  attributes: AttributeType[];
};

const Attributes = ({
  attributes,
  mode,
  classes: customClasses,
  singleColumn,
  display = 'block',
}: Props): JSX.Element => {
  const isLarge = mode === 'large';
  const [firstPart, secondPart] = useMemo(() => {
    if (mode !== 'large' || singleColumn) {
      return [attributes, []];
    }

    const half = Math.ceil(attributes.length / 2);
    return [attributes.slice(0, half), attributes.slice(half)];
  }, [attributes, mode, singleColumn]);

  const isEvenAtrributesLength = firstPart.length % 2;

  return (
    <div className={classNames({ [classes.largeContainer]: isLarge })}>
      <div className={classNames(classes.wrapper, customClasses?.wrapper)}>
        {firstPart.map(({ id, name, value, attributes: nestedAttributes }) => (
          <div
            className={classNames(classes.attribute, classes.evenBackgroundColor, {
              [classes.large]: isLarge,
            })}
            key={id}
          >
            <Attribute name={name} value={value} attributes={nestedAttributes} mode={mode} display={display} />
          </div>
        ))}
      </div>
      {!!secondPart.length && (
        <div className={classes.wrapper}>
          {secondPart.map(({ id, name, value, attributes: nestedAttributes }) => (
            <div
              className={classNames(
                classes.attribute,
                classes[isEvenAtrributesLength ? 'oddBackgroundColor' : 'evenBackgroundColor'],
                { [classes.large]: isLarge }
              )}
              key={id}
            >
              <Attribute name={name} value={value} attributes={nestedAttributes} mode={mode} display={display} />
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default memo(Attributes);
